import {
  ODataHeader,
  ODataString,
  ODataInteger,
  ODataBoolean,
  HeaderAlignment,
} from "pbas-vue-components";
import { translate2 } from "../trans2";

const headers = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "globals.order",
    type: new ODataInteger("Order", { alignment: HeaderAlignment.Left }),
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("Translations[]/Name", {
      getString: (item) => {
        return translate2(item, "Name");
      },
    }),
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/Image/PhysicalFile/Id"),
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "headers.coveragecategories.image",
    type: new ODataString("Translations[]/Image/PhysicalFile/Path", {
      getHtml: function(item) {
        const image = translate2(item, "Image");
        return image?`<img src='${
          image.PhysicalFile.Path
        }' style='max-height: 120px'/>`:"";
      },
    }),
    sortable: false,
    visible: true,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/Image/PhysicalFile/Name"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "PlanId",
    type: new ODataString("PlanId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "headers.coveragecategories.content_items",
    type: new ODataString(
      "CoverageTileItemCoverageTiles[]/CoverageTileItem/Translations[]/Name",
      {
        getHtml: (item, type) => {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
          );
        },
        getString: (item) => {
          return item.CoverageTileItemCoverageTiles.map((o) =>
            translate2(o.CoverageTileItem, "Name")
          ).join(", ");
        },
      }
    ),
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
    sortable: false,
    version: 1,
  }),
  new ODataHeader({
    type: new ODataString(
      "CoverageTileItemCoverageTiles[]/CoverageTileItem/Translations[]/LanguageCode"
    ),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString(
      "CoverageTileItemCoverageTiles[]/CoverageTileItem/Translations[]/Id"
    ),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.class",
    type: new ODataString("ClassCoverageTile/Class"),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
    version: 1
  }),
  new ODataHeader({
    type: new ODataString("AllowedGuest"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
];
export default headers;
